const user = {
  name: "Yousaf Nabi",
  avatar: "img/macos/ui/avatar.jpg",
};

export default user;
